<template>
    <section-container title="Estado do Veículo" icon="car" css-class="car-view-container">
        <div class="car-visualization">
            <div class="car-outline">
                <!-- Representação visual do carro -->
                <div class="car-shape">
                    <div class="car-windshield"></div>
                    <div class="car-body"></div>
                    <div class="car-wheel car-wheel-front"></div>
                    <div class="car-wheel car-wheel-back"></div>
                </div>

                <!-- Pontos de avaria -->
                <div class="damage-point front" :class="{'active': damageAreas.frontal}">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="damage-point right" :class="{'active': damageAreas.right}">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="damage-point rear" :class="{'active': damageAreas.rear}">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="damage-point left" :class="{'active': damageAreas.left}">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="damage-point top" :class="{'active': damageAreas.ceiling}">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
            </div>

            <div class="legend mt-3">
                <div class="legend-item">
                    <div class="legend-color ok"></div>
                    <div class="legend-text">OK</div>
                </div>
                <div class="legend-item">
                    <div class="legend-color damaged"></div>
                    <div class="legend-text">Com avaria</div>
                </div>
            </div>
        </div>
    </section-container>
</template>

<script>
import SectionContainer from './SectionContainer.vue';

export default {
    name: "DamageVisualization",
    components: {
        SectionContainer
    },
    props: {
        damageAreas: {
            type: Object,
            default: () => ({
                frontal: false,
                right: false,
                rear: false,
                left: false,
                ceiling: false
            })
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Modals/Checklist/DamageVisualization.vue